import { gql } from '@apollo/client';

const getVariantQuery = gql`
  query GetVariantRequest(
    $grain: OdProtosVariantData_GrainInput
    $key: String!
    $props: GoogleProtobuf_StructInput
    $autoImpression: Boolean
  ) {
    variant {
      getVariant(
        input: { grain: $grain, key: $key, props: $props, autoImpression: $autoImpression }
      ) {
        variant {
          value
        }
      }
    }
  }
`;

export default getVariantQuery;
